import React, { createContext, useContext, useMemo, useState, useCallback } from "react";

// types: trip | route | license | expense | driver | viewer | document | material | client | sensor | reminder | report
const QuickModalContext = createContext(null);

export function QuickModalProvider({ children }) {
  const [openType, setOpenType] = useState(null);
  const [payload, setPayload] = useState(null);

  const openModal = useCallback((type, nextPayload = null) => {
    setOpenType(type);
    setPayload(nextPayload);
  }, []);
  const closeModal = useCallback(() => {
    setOpenType(null);
    setPayload(null);
  }, []);

  const value = useMemo(
    () => ({ openType, openModal, closeModal, payload }),
    [closeModal, openModal, openType, payload]
  );

  return <QuickModalContext.Provider value={value}>{children}</QuickModalContext.Provider>;
}

export function useQuickModal() {
  const ctx = useContext(QuickModalContext);
  if (!ctx) throw new Error("useQuickModal must be used inside QuickModalProvider");
  return ctx;
}
